import {
	Component, Input, OnInit, OnChanges, SimpleChanges, SimpleChange,
	ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, QueryList, ViewChildren, ElementRef
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { SelectItem } from 'primeng/api';
//import { Table } from 'primeng/table';
import { UvTable } from 'widget';
import { ValueEncoder } from 'DiscoveryEngine.TS/Utils';
import { IpAddress, MacAddress } from 'DiscoveryEngine.TS/Core';
import {
	InfoSetView, InfoSetViewColumn, InfoSetViewEntry, InfoSetViewValue
} from 'UvExplorerServer.Dtos.TS/Session';


@Component({
	selector: 'info-viewer',
	templateUrl: './info-viewer.component.html',
	styleUrls: ['./info-viewer.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoViewerComponent implements OnInit, OnChanges {

	@Input()
	public infoSetView: InfoSetView;

	@Input()
	public scrollHeight: string;

	@Input()
	public selectionMode: string;

	@Input()
	public bodyCmItems: MenuItem[];

	@Input()
	public show: boolean;

	@ViewChildren('filter')
	public filters: QueryList<ElementRef<HTMLInputElement>>;

	@ViewChild('dt', { static: true })
	public dt: UvTable;

	public cols: any[];
	public entries: any[];
	public cmItems: MenuItem[];
	public displaySelectColumnsDialog: boolean;
	public selectItems: SelectItem[];
	public selection: any;

	public readonly VirtualScrollItemSize = 29;
	public get TableRowStyle(): string {
		return `height: ${this.VirtualScrollItemSize}px;`;
	}

	constructor(private changeDetector: ChangeDetectorRef) {
		this.cmItems = this.getContextMenuItems();
		this.displaySelectColumnsDialog = false;
		this.scrollHeight = "calc(25vh)";
		this.selectionMode = "none";
		this.bodyCmItems = this.getContextMenuItems();
		this.selection = undefined;
	}

	public cellClasses(field: string, rowData: any): string {
		let classes = "";
		if (field === "portStatus" && !!rowData.portStatus) {
			if (rowData.portStatus.toLowerCase() === "open") {
				classes = "port-status-open";
			}
			else {
				classes = "port-status-closed";
			}
		}
		return classes;
	}

	protected get hasBodyContextMenuItems(): boolean {
		return (!!this.bodyCmItems && (this.bodyCmItems.length > 0));
	}

	protected getContextMenuItems(): MenuItem[] {
		return [
			{ label: "Select Columns", command: (event) => this.showSelectColumnsDialog() }
		];
	}

	public onBodyCmClick(entry: any): void {
		if (this.selectionMode != "none") {
			this.selection = entry;
		}
	}

	public ngOnInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {

		if (changes["infoSetView"] || changes["show"]) {
			this.updateData();
		}

		if (this.infoSetView) {
			if (this.filters) {
				this.filters.forEach((filter: ElementRef<HTMLInputElement>) => {
					filter.nativeElement.value = "";
				});
			}

			if (!!this.cols && !!this.dt) {
				this.cols.forEach((col) => {
					this.dt.filter("", col.field, 'contains')
				});
			}
		}
	}

	private updateData(): void {
		this.cols = [];
		this.entries = [];
		this.selectItems = [];

		if (this.infoSetView && this.show) {

			// // Determine which columns contain non-empty values
			// let colHasData: boolean[] = new Array(this.infoSetView.columns.length);
			// this.infoSetView.entries.forEach((viewEntry: InfoSetViewEntry) => {
			// 	for (let i = 0; i < viewEntry.values.length; ++i) {
			// 		if (viewEntry.values[i].value) {
			// 			colHasData[i] = true;
			// 		}
			// 	}
			// }, this);

			// Initialize columns
			for (let i = 0; i < this.infoSetView.columns.length; ++i) {
				let viewCol = this.infoSetView.columns[i];

				let col = {
					index: i,
					field: viewCol.field,
					header: viewCol.header,
					sortable: "custom",
					sortFunction: (event) => this.doCustomSort(event)
				};

				if (viewCol.visible /*&& colHasData[i]*/) {
					this.cols.push(col);
				}
				this.selectItems.push({ label: col.header, value: col });
			}

			// Initialize entries
			this.infoSetView.entries.forEach((viewEntry: InfoSetViewEntry) => {
				let entry = {};

				for (let i = 0; i < viewEntry.values.length; ++i) {
					let col = this.infoSetView.columns[i];
					let cell = viewEntry.values[i];

					// Initialize value property
					entry[col.field] = cell.value;

					// Initialize tag property
					let tag: any = undefined;

					switch (col.type) {
						case "string":
							tag = cell.tagText;
							break;
						case "number":
							if (cell.value)
								tag = Number.parseFloat(cell.tagText);
							break;
						case "ipaddress":
							if (cell.value)
								tag = IpAddress.Create(cell.tagText);					
							break;
						case "macaddress":
							if (cell.value)
								tag = MacAddress.CreateFromString(cell.tagText);
							break;
						default:
							throw new Error("Invalid InfoSetView column type: " + col.type);
					}

					let tagFieldName = col.field + "Tag";
					entry[tagFieldName] = tag;

					// Initialize type property
					let typeFieldName = col.field + "Type";
					entry[typeFieldName] = col.type;
				}

				this.entries.push(entry);
			}, this);
		}
	}

	// Recreate entries when infoset values have changed (but not columns)
	public patchData(newInfoSetView: InfoSetView): void {
		this.entries = [];

		// //<TEST>
		// let newName = Math.random().toString();
		// //</TEST>

		// Create new entries.
		newInfoSetView.entries.forEach((viewEntry: InfoSetViewEntry) => {
			let entry = {};

			for (let i = 0; i < viewEntry.values.length; ++i) {
				let col = this.infoSetView.columns[i];
				let cell = viewEntry.values[i];

				// Initialize value property
				entry[col.field] = cell.value;

				// //<TEST>
				// if (col.field == 'name' || col.field == 'bpName') {
				// 	entry[col.field] = newName;
				// }
				// //</TEST>

				// Initialize tag property
				let tag: any = undefined;

				switch (col.type) {
					case "string":
						tag = cell.tagText;
						break;
					case "number":
						if (cell.value)
							tag = Number.parseFloat(cell.tagText);
						break;
					case "ipaddress":
						if (cell.value)
							tag = IpAddress.Create(cell.tagText);					
						break;
					case "macaddress":
						if (cell.value)
							tag = MacAddress.CreateFromString(cell.tagText);
						break;
					default:
						throw new Error("Invalid InfoSetView column type: " + col.type);
				}

				let tagFieldName = col.field + "Tag";
				entry[tagFieldName] = tag;

				// Initialize type property
				let typeFieldName = col.field + "Type";
				entry[typeFieldName] = col.type;
			}

			this.entries.push(entry);
		}, this);
		
		this.changeDetector.markForCheck();

		// Apply filters to new entries.
		// console.assert(!!this.filters && !!this.cols && (this.filters.length == this.cols.length));
		// if (!!this.filters && !!this.cols && (this.filters.length == this.cols.length)) {
		// 	for (let i = 0; i < this.filters.length; ++i) {
		// 		let filter: ElementRef<HTMLInputElement> = this.filters.get(i);
		// 		let filterValue: string = filter.nativeElement.value;
		// 		if (filterValue) {
		// 			let col = this.cols[i];
		// 			console.log(`Applying filter '${filterValue}' to column '${col.field}' `);
		// 			this.dt.filter(filterValue, col.field, 'contains');
		// 		}
		// 	}
		// }
	}

	public doCustomSort(event): void {
		let _self = this;
		let comparer = function (a: any, b: any): number {

			let tagFieldName = event.field + "Tag";
			let aTag = a[tagFieldName];
			let bTag = b[tagFieldName];

			let typeFieldName = event.field + "Type";
			let type: string = a[typeFieldName];

			let result = 0;
			switch (type) {
				case "string":
					result = _self.compareStrings(aTag, bTag);
					break;
				case "number":
					result = _self.compareNumbers(aTag, bTag);
					break;
				case "ipaddress":
					result = _self.compareIpAddresses(aTag, bTag);
					break;
				case "macaddress":
					result = _self.compareMacAddresses(aTag, bTag);
					break;
				default:
					throw new Error("Invalid InfoSetView column type: " + type);
			}

			return result * event.order;
		}

		this.entries.sort(comparer);
	}

	private showSelectColumnsDialog(): void {
		this.displaySelectColumnsDialog = true;
	}

	public onColumnSelectionChange(event): void {
		this.cols.sort((a, b) => {
			return a.index - b.index;
		});
	}

	public closeSelectColumnsDialog(): void {
		this.displaySelectColumnsDialog = false;
	}

	public onSelectColumnsDialogHide(): void {
		if (this.cols.length == 0) {
			this.cols.push(this.selectItems[0].value);
			this.changeDetector.detectChanges();
		}
	}

	protected compareStrings(a: string, b: string): number {
		if (a && b)
			return a.localeCompare(b);
		else if (a)
			return 1;
		else if (b)
			return -1;
		else
			return 0;
	}

	protected compareNumbers(a: number, b: number): number {
		if (a !== undefined && b !== undefined)
			return ((a < b) ? -1 : ((a > b) ? 1 : 0));
		else if (a !== undefined)
			return 1;
		else if (b !== undefined)
			return -1;
		else
			return 0;
	}

	protected compareIpAddresses(a: IpAddress, b: IpAddress): number {
		if (a && b)
			return a.CompareTo(b);
		else if (a)
			return 1;
		else if (b)
			return -1;
		else
			return 0;
	}

	protected compareMacAddresses(a: MacAddress, b: MacAddress): number {
		if (a && b)
			return a.CompareTo(b);
		else if (a)
			return 1;
		else if (b)
			return -1;
		else
			return 0;
	}

}
